<ion-content class="login-v2-content">
  <div class="login-shell">

    <!-- ── HERO HEADER ── -->
    <div class="hero">
      <div class="hero__buttons">
        <button type="button" class="hero__back" (click)="goBack()" aria-label="Retour">
          <ion-icon name="chevron-back-outline" aria-hidden="true"></ion-icon>
        </button>

        <div class="hero__logo" aria-hidden="true">
          <ion-icon name="construct-outline"></ion-icon>
        </div>
      </div>

      <h1 class="hero__title">{{ 'LOGIN_PAGE.WELCOME_TITLE' | translate }} !</h1>
      <p class="hero__sub">{{ 'LOGIN_PAGE.WELCOME_SUBTITLE' | translate }}</p>
    </div>

    <!-- ── FORM CARD ── -->
    <form class="form-card" [formGroup]="loginForm" (ngSubmit)="login()">
      <!-- Email -->
      <div class="field">
        <label class="field__label" for="login-email">
          <ion-icon name="mail-outline" aria-hidden="true"></ion-icon>
          {{ 'FORM.LABELS.EMAIL' | translate }}
        </label>
        <div class="field__wrap">
          <input id="login-email" class="field__input" type="email" inputmode="email" autocomplete="email"
            autocorrect="off" autocapitalize="off" spellcheck="false" formControlName="email"
            placeholder="exemple@gmail.com" (keyup)="emailError = false"
            [class.field__input--error]="submitted && emailError && f['email'].value?.length" />
          <ion-icon name="mail-outline" class="field__icon" aria-hidden="true"></ion-icon>
        </div>
        <p *ngIf="submitted && emailError && f['email'].value?.length" class="field__error">
          <ion-icon name="alert-circle-outline" aria-hidden="true"></ion-icon>
          {{ emailErrorMessage }}
        </p>
      </div>

      <!-- Password -->
      <div class="field">
        <label class="field__label" for="login-password">
          <ion-icon name="lock-closed-outline" aria-hidden="true"></ion-icon>
          {{ 'FORM.LABELS.PASSWORD' | translate }}
        </label>
        <div class="field__wrap">
          <input id="login-password" class="field__input field__input--with-toggle" [type]="textType"
            autocomplete="current-password" formControlName="password" placeholder="••••••••"
            (keyup)="passwordError = false"
            [class.field__input--error]="submitted && passwordError && f['password'].value?.length" />
          <ion-icon name="lock-closed-outline" class="field__icon" aria-hidden="true"></ion-icon>
          <button type="button" class="field__toggle" (click)="togglePasswordVisibility()"
            [attr.aria-label]="textType === 'password' ? 'Afficher le mot de passe' : 'Masquer le mot de passe'">
            <ion-icon [name]="textType === 'password' ? 'eye-off-outline' : 'eye-outline'"
              aria-hidden="true"></ion-icon>
          </button>
        </div>
        <p *ngIf="submitted && passwordError && f['password'].value?.length" class="field__error">
          <ion-icon name="alert-circle-outline" aria-hidden="true"></ion-icon>
          {{ passwordErrorMessage }}
        </p>
      </div>

      <!-- Remember + Forgot -->
      <div class="options-row">
        <ion-checkbox class="remember" labelPlacement="end" [mode]="'md'" (ionChange)="onRememberMeChange($event)">
          Se souvenir de moi
        </ion-checkbox>
        <a class="forgot" [routerLink]="['/email-forgot-password']">
          {{ 'LOGIN_PAGE.FORGOT_PASSWORD' | translate }}
        </a>
      </div>

      <!-- CTA -->
      <button type="submit" class="btn-login" [disabled]="isLoading || loadingConnectAccount">
        <ion-spinner *ngIf="isLoading && !loadingConnectAccount" name="crescent"></ion-spinner>
        <ng-container *ngIf="!(isLoading && !loadingConnectAccount)">
          Se connecter
          <ion-icon name="arrow-forward-outline" aria-hidden="true"></ion-icon>
        </ng-container>
      </button>

      <!-- Divider -->
      <div class="divider">
        <span class="divider__line"></span>
        <span class="divider__text">ou continuer avec</span>
        <span class="divider__line"></span>
      </div>

      <!-- Social buttons -->
      <div class="socials">
        <button *ngIf="platform === 'ios'" type="button" class="btn-social btn-social--apple"
          (click)="signInWithApple()"
          [disabled]="isLoading || loadingApple || loadingConnectAccount"
          [attr.aria-label]="'BUTTONS.CONTINUE_APPLE' | translate">
          <ion-spinner *ngIf="loadingApple" class="btn-social__spinner" name="crescent" aria-hidden="true"></ion-spinner>
          <ng-container *ngIf="!loadingApple">
            <ion-icon name="logo-apple" aria-hidden="true"></ion-icon>
            {{ "BUTTONS.CONTINUE_APPLE" | translate }}
          </ng-container>
        </button>
        <button
          type="button"
          class="btn-social btn-social--google"
          (click)="signInWithGoogle()"
          [disabled]="isLoading || loadingGoogle || loadingConnectAccount"
          [attr.aria-label]="'BUTTONS.CONTINUE_GOOGLE' | translate"
        >
          <ion-spinner
            *ngIf="loadingGoogle"
            class="btn-social__spinner"
            name="crescent"
            aria-hidden="true"
          ></ion-spinner>
          <ng-container *ngIf="!loadingGoogle">
            <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"
                fill="#4285F4"
              />
              <path
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                fill="#34A853"
              />
              <path
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18A10.96 10.96 0 001 12c0 1.77.42 3.45 1.18 4.93l3.66-2.84z"
                fill="#FBBC05"
              />
              <path
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                fill="#EA4335"
              />
            </svg>
            {{ 'BUTTONS.CONTINUE_GOOGLE' | translate }}
          </ng-container>
        </button>
      </div>
    </form>

    <!-- ── SAVED ACCOUNTS ── -->
    <div *ngIf="savedAccounts.length > 0" class="saved-section">
      <div class="saved-section__title">Comptes enregistrés</div>
      <div *ngFor="let account of savedAccounts" class="saved-account" [class.saved-account--loading]="account.loading"
        (click)="onSelectAccount(account)">
        <ion-spinner *ngIf="account.loading" class="saved-account__spinner" name="circular"></ion-spinner>
        <img class="saved-account__avatar" [src]="account.image || '/assets/img/avatar-2.png'" alt="" />
        <div class="saved-account__info">
          <div class="saved-account__name">
            {{ account.firstname }} {{ account.lastname }}
          </div>
          <div class="saved-account__email">{{ account.email }}</div>
        </div>
        <button *ngIf="!account.loading" type="button" class="saved-account__delete"
          (click)="deleteSavedAccount(account, $event)" aria-label="Supprimer le compte">
          <ion-icon name="trash-outline" aria-hidden="true"></ion-icon>
        </button>
        <ion-icon *ngIf="!account.loading" class="saved-account__arrow" name="chevron-forward-outline"
          aria-hidden="true"></ion-icon>
      </div>
    </div>

    <!-- ── TRUST BADGES ── -->
    <div class="trust-row" aria-hidden="true">
      <div class="trust-item">
        <div class="trust-item__icon trust-item__icon--shield">
          <ion-icon name="shield-checkmark"></ion-icon>
        </div>
        <span class="trust-item__text">Sécurisé</span>
      </div>
      <div class="trust-item">
        <div class="trust-item__icon trust-item__icon--lock">
          <ion-icon name="lock-closed"></ion-icon>
        </div>
        <span class="trust-item__text">Chiffré</span>
      </div>
      <div class="trust-item">
        <div class="trust-item__icon trust-item__icon--fast">
          <ion-icon name="flash"></ion-icon>
        </div>
        <span class="trust-item__text">Rapide</span>
      </div>
    </div>

    <!-- ── FOOTER ── -->
    <div class="footer">
      <div class="footer__text">
        {{ 'LOGIN_PAGE.NO_ACCOUNT' | translate }}
        <a class="footer__link" [routerLink]="['/register']">
          {{ 'LOGIN_PAGE.REGISTER' | translate }}
        </a>
      </div>
      <div class="footer__version">
        <app-version></app-version>
      </div>
    </div>

  </div>
</ion-content>